import { FormControlLabel, FormGroup, TextField } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TableRow from "@material-ui/core/TableRow";
import { DatePicker } from "@material-ui/pickers";
import {
  Bagde,
  StyleCheckbox,
  StyledTableCell,
  useStyles,
} from "components/request-document/components/Commons";
import usePrevious from "libs/hooks/usePrevious";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { selectMasterData } from "redux/modules/masterSlice";

export default function JobSection({
  colSpan = 6,
  bagdeStart = 19,
  formik,
  prefixFieldName = "",
}) {
  const classes = useStyles();
  const masterData = useSelector(selectMasterData);

  // console.log(masterData);
  const jobPositionConfig = get(masterData, "jobPositionConfig", []);

  const prevJobPosition = usePrevious(formik.values.JobPosition);
  const isJobPositionChange =
    prevJobPosition && prevJobPosition !== formik.values.JobPosition;
  const canEdit = useSelector(canEditForm);
  useEffect(() => {
    if (isJobPositionChange) {
      formik.setFieldValue("JobSubPosition", "");
    }
  }, [formik, isJobPositionChange]);

  const index = 0;
  const jobTable = get(
    formik.values,
    `document.JobPositionWorkPermit.${index}`,
    {}
  );

  const jobSubPositionConfig =
    jobPositionConfig.find((job) => job.jobID === jobTable.jobID)
      ?.jobSubPosition || [];

  const isYearMonth = formik.values?.document.WPContractTermType === "Y";
  const isPeriod = formik.values?.document.WPContractTermType === "P";
  const isOE = formik.values?.document.WPContractTermType === "OE";
  const isOther = formik.values?.document.WPContractTermType === "O";
  const isDYearMonth = formik.values?.document.DesiredWorkingPeriodID === "Y";
  const isDPeriod = formik.values?.document.DesiredWorkingPeriodID === "P";

  return (
    <>
      <TableRow>
        <StyledTableCell colSpan={colSpan}>
          <div className={classes.cellContent}>
            <div
              className={classes.flexRow}
              style={{ flex: 1, display: "flex" }}
            >
              <InputLabel>Job position</InputLabel>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                style={{ marginLeft: 16, flex: 1 }}
              >
                <InputLabel>Select Job position</InputLabel>
                <Select
                  disabled={!canEdit}
                  label="Select Job position"
                  name={`document.JobPositionWorkPermit.${index}.jobID`}
                  defaultValue=""
                  // value={get(
                  //   formik.values,
                  //   `document.JobTable.${index}.jobID`,
                  //   ""
                  // )}
                  value={formik.values.document.JobPositionWorkPermit[0].jobID}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  {jobPositionConfig.map((jobPosition) => (
                    <MenuItem key={jobPosition.jobID} value={jobPosition.jobID}>
                      {jobPosition.jobName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                style={{ marginLeft: 16, flex: 1 }}
              >
                <InputLabel>Select Job Sub position</InputLabel>

                <Select
                  disabled={!canEdit}
                  label="Select Job Sub position"
                  name={`document.JobPositionWorkPermit.${index}.jobsubID`}
                  value={
                    formik.values.document.JobPositionWorkPermit[0].jobsubID
                  }
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  {jobSubPositionConfig.map((jobPosition) => (
                    <MenuItem
                      key={jobPosition.jobsubID}
                      value={jobPosition.jobsubID}
                    >
                      {jobPosition.jobsubName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={colSpan}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>
                Job Title (Type of work according to WP.46 form)
              </InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name={`document.JobPositionWorkPermit.${index}.jobTitle`}
                value={get(
                  formik.values,
                  `document.JobPositionWorkPermit.${index}.jobTitle`,
                  ""
                )}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError(
                  `document.JobPositionWorkPermit.${index}.jobTitle`,
                  formik
                )}
                helperText={getErrorMessage(
                  `document.JobPositionWorkPermit.${index}.jobTitle`,
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={colSpan}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>
                Job description (Nature of work according to Form WP.46)
              </InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name={`document.JobPositionWorkPermit.${index}.jobDesc`}
                value={get(
                  formik.values,
                  `document.JobPositionWorkPermit.${index}.jobDesc`,
                  ""
                )}
                error={isError(
                  `document.JobPositionWorkPermit.${index}.jobDesc`,
                  formik
                )}
                helperText={getErrorMessage(
                  `document.JobPositionWorkPermit.${index}.jobDesc`,
                  formik
                )}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                multiline
                rows={5}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div style={{ width: "50%" }}>
            <div className={classes.wrapField}>
              <InputLabel style={{ fontWeight: "bold" }}>
                Contract term
              </InputLabel>
            </div>
          </div>
          <FormGroup row>
            <FormControlLabel
              control={
                <StyleCheckbox
                  disabled={!canEdit}
                  name="Year"
                  checked={isYearMonth}
                  onChange={() =>
                    formik.setFieldValue("document.WPContractTermType", "Y")
                  }
                />
              }
              label="Year - Months"
            />
            <FormControlLabel
              control={
                <StyleCheckbox
                  disabled={!canEdit}
                  name="Period (dd-mm-yyyy to dd-mm-yyyy)"
                  checked={isPeriod}
                  onChange={() =>
                    formik.setFieldValue("document.WPContractTermType", "P")
                  }
                />
              }
              label="Period"
            />
            <FormControlLabel
              control={
                <StyleCheckbox
                  disabled={!canEdit}
                  name="Open-ended (unlimited)"
                  checked={isOE}
                  onChange={() =>
                    formik.setFieldValue("document.WPContractTermType", "OE")
                  }
                />
              }
              label="Open-ended (unlimited)"
            />
            <FormControlLabel
              control={
                <StyleCheckbox
                  disabled={!canEdit}
                  name="Other"
                  checked={isOther}
                  onChange={() =>
                    formik.setFieldValue("document.WPContractTermType", "O")
                  }
                />
              }
              label="Other ( Please specify )"
            />
          </FormGroup>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flex: 1,
            }}
          >
            {isYearMonth && (
              <>
                <TextField
                  disabled={!canEdit}
                  className={classes.formControl}
                  variant="outlined"
                  placeholder="Year"
                  // type="number"
                  onKeyDown={(e) => {
                    const pattern = /[^0-9]/g;
                    const isNotAllow =
                      e.key.length === 1 && pattern.test(e.key);

                    if (isNotAllow) {
                      e.preventDefault();
                    }
                  }}
                  name="document.WPContractYear"
                  value={formik.values?.document.WPContractYear}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={isError("document.WPContractYear", formik)}
                  helperText={getErrorMessage(
                    "document.WPContractYear",
                    formik
                  )}
                />
                <TextField
                  disabled={!canEdit}
                  className={classes.formControl}
                  variant="outlined"
                  placeholder="Month"
                  // type="number"
                  onKeyDown={(e) => {
                    const pattern = /[^0-9]/g;
                    const isNotAllow =
                      e.key.length === 1 && pattern.test(e.key);

                    if (isNotAllow) {
                      e.preventDefault();
                    }
                  }}
                  name="document.WPContractMonth"
                  value={formik.values?.document.WPContractMonth}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={isError("document.WPContractMonth", formik)}
                  helperText={getErrorMessage(
                    "document.WPContractMonth",
                    formik
                  )}
                />
              </>
            )}
            {isPeriod && (
              <>
                <DatePicker
                  disabled={!canEdit}
                  className={classes.formControl}
                  inputVariant="outlined"
                  disableFuture={false}
                  openTo="year"
                  format="DD-MM-YYYY"
                  label="Start date"
                  views={["year", "month", "date"]}
                  name="document.WPContractPeriodFrom"
                  maxDate={
                    formik.values?.document.WPContractPeriodFrom
                      ? formik.values?.document.WPContractPeriodFrom
                      : undefined
                  }
                  value={formik.values?.document.WPContractPeriodFrom || null}
                  onChange={(date) => {
                    formik.setFieldValue(
                      "document.WPContractPeriodFrom",
                      date.format("YYYY-MM-DD")
                    );
                  }}
                  error={isError("document.WPContractPeriodFrom", formik)}
                  helperText={getErrorMessage(
                    "document.WPContractPeriodFrom",
                    formik
                  )}
                />
                <DatePicker
                  disabled={!canEdit}
                  className={classes.formControl}
                  inputVariant="outlined"
                  // disableFuture={false}
                  openTo="year"
                  format="DD-MM-YYYY"
                  label="End date"
                  views={["year", "month", "date"]}
                  name="document.WPContractPeriodTo"
                  minDate={
                    formik.values?.document.WPContractPeriodTo
                      ? formik.values?.document.WPContractPeriodTo
                      : undefined
                  }
                  value={formik.values?.document.WPContractPeriodTo || null}
                  onChange={(date) => {
                    formik.setFieldValue(
                      "document.WPContractPeriodTo",
                      date.format("YYYY-MM-DD")
                    );
                  }}
                  error={isError("document.WPContractPeriodTo", formik)}
                  helperText={getErrorMessage(
                    "document.WPContractPeriodTo",
                    formik
                  )}
                />
              </>
            )}
            {isOther && (
              <TextField
                disabled={!canEdit}
                className={classes.formControl}
                variant="outlined"
                placeholder="Please specify"
                name="document.WPContractOther"
                value={formik.values?.document.WPContractOther}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.WPContractOther", formik)}
                helperText={getErrorMessage("document.WPContractOther", formik)}
              />
            )}
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div style={{ width: "50%" }}>
            <div className={classes.wrapField}>
              <InputLabel style={{ fontWeight: "bold" }}>
                Desired working period
              </InputLabel>
            </div>
          </div>
          <FormGroup row>
            <FormControlLabel
              control={
                <StyleCheckbox
                  disabled={!canEdit}
                  name="Year"
                  checked={isDYearMonth}
                  onChange={() =>
                    formik.setFieldValue("document.DesiredWorkingPeriodID", "Y")
                  }
                />
              }
              label="Year - Months"
            />
            <FormControlLabel
              control={
                <StyleCheckbox
                  disabled={!canEdit}
                  name="Period (dd-mm-yyyy to dd-mm-yyyy)"
                  checked={isDPeriod}
                  onChange={() =>
                    formik.setFieldValue("document.DesiredWorkingPeriodID", "P")
                  }
                />
              }
              label="Period"
            />
          </FormGroup>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flex: 1,
            }}
          >
            {isDYearMonth && (
              <>
                <TextField
                  disabled={!canEdit}
                  className={classes.formControl}
                  variant="outlined"
                  placeholder="Year"
                  // type="number"
                  onKeyDown={(e) => {
                    const pattern = /[^0-9]/g;
                    const isNotAllow =
                      e.key.length === 1 && pattern.test(e.key);

                    if (isNotAllow) {
                      e.preventDefault();
                    }
                  }}
                  name="document.DesiredWorkingPeriodYear"
                  value={formik.values?.document.DesiredWorkingPeriodYear}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={isError("document.DesiredWorkingPeriodYear", formik)}
                  helperText={getErrorMessage(
                    "document.DesiredWorkingPeriodYear",
                    formik
                  )}
                />
                <TextField
                  disabled={!canEdit}
                  className={classes.formControl}
                  variant="outlined"
                  placeholder="Month"
                  // type="number"
                  onKeyDown={(e) => {
                    const pattern = /[^0-9]/g;
                    const isNotAllow =
                      e.key.length === 1 && pattern.test(e.key);

                    if (isNotAllow) {
                      e.preventDefault();
                    }
                  }}
                  name="document.DesiredWorkingPeriodMonth"
                  value={formik.values?.document.DesiredWorkingPeriodMonth}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={isError("document.DesiredWorkingPeriodMonth", formik)}
                  helperText={getErrorMessage(
                    "document.DesiredWorkingPeriodMonth",
                    formik
                  )}
                />
              </>
            )}
            {isDPeriod && (
              <>
                <DatePicker
                  disabled={!canEdit}
                  className={classes.formControl}
                  inputVariant="outlined"
                  disableFuture={false}
                  openTo="year"
                  format="DD-MM-YYYY"
                  label="Start date"
                  views={["year", "month", "date"]}
                  name="document.PeriodStart"
                  maxDate={
                    formik.values?.document.PeriodStart
                      ? formik.values?.document.PeriodStart
                      : undefined
                  }
                  value={formik.values?.document.PeriodStart || null}
                  onChange={(date) => {
                    formik.setFieldValue(
                      "document.PeriodStart",
                      date.format("YYYY-MM-DD")
                    );
                  }}
                  error={isError("document.PeriodStart", formik)}
                  helperText={getErrorMessage("document.PeriodStart", formik)}
                />
                <DatePicker
                  disabled={!canEdit}
                  className={classes.formControl}
                  inputVariant="outlined"
                  // disableFuture={false}
                  openTo="year"
                  format="DD-MM-YYYY"
                  label="End date"
                  views={["year", "month", "date"]}
                  name="document.PeriodEnd"
                  minDate={
                    formik.values?.document.PeriodEnd
                      ? formik.values?.document.PeriodEnd
                      : undefined
                  }
                  value={formik.values?.document.PeriodEnd || null}
                  onChange={(date) => {
                    formik.setFieldValue(
                      "document.PeriodEnd",
                      date.format("YYYY-MM-DD")
                    );
                  }}
                  error={isError("document.WPContractPeriodTo", formik)}
                  helperText={getErrorMessage(
                    "document.WPContractPeriodTo",
                    formik
                  )}
                />
              </>
            )}
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Name of contact person in Thailand</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.WPContactPersonInThai"
                value={formik.values.document.WPContactPersonInThai}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.WPContactPersonInThai", formik)}
                helperText={getErrorMessage(
                  "document.WPContactPersonInThai",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={4}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Relationship with the applicant</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.WPContactRelationship"
                value={formik.values.document.WPContactRelationship}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.WPContactRelationship", formik)}
                helperText={getErrorMessage(
                  "document.WPContactRelationship",
                  formik
                )}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>E-mail address</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.WPContactEmail"
                value={formik.values.document.WPContactEmail}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.WPContactEmail", formik)}
                helperText={getErrorMessage("document.WPContactEmail", formik)}
              />
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={4}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Mobile phone number</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.WPContactMobile"
                inputProps={{ maxLength: 10 }}
                onKeyDown={(e) => {
                  const pattern = /[^0-9]/g;
                  const isNotAllow = e.key.length === 1 && pattern.test(e.key);

                  if (isNotAllow) {
                    e.preventDefault();
                  }
                }}
                value={formik.values.document.WPContactMobile}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("document.WPContactMobile", formik)}
                helperText={getErrorMessage("document.WPContactMobile", formik)}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
    </>
  );
}
